import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";

function AdminDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="container-fluid p-0 vh-100">
      <div className="row h-100 g-0">
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

        <div className="col bg-light overflow-auto">
          <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
            <h1 className="h5">Tableau d'administration</h1>
            {!sidebarOpen && (
              <button
                className="btn btn-dark d-sm-none"
                onClick={toggleSidebar}
              >
                <i className="bi bi-list"></i>
              </button>
            )}
          </div>

          <div className="p-4">
            <Outlet /> {/* Sous-pages ici */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
